let $ = jQuery.noConflict(),
    devMode,
    mobileCheck = false,
    pageTransition,
    pageTransitionEnabled = false,
    resizeCallbacks = [],
    clickOrTouch,
    mobileResizeCallbacks = [];

$(function () {
    new StarterKitMcube();
    // Composants Mobile & Desktop
    new CatalogModels();
    new RealSlider();
    new CardsSwiper();
    new Collapse();
    new GoogleMap();
    new Header();
    new Home();
    new OpinionSwiper();
    new Filters();
    new SingleModels();
    new SingleAgency();
    new SingleTypes();
    new SingleNews();
    new MenuMobile();
    new MenuDesktop();
    new NavInternal();
    new AlertMessage();
    new DataLayer();
    new ContactForm();
    new ShowPhoneNumber();

    new PageLands();
    new SingleLand();
    new SideForm();
});


